/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type GetMinervaViewSummaryQueryVariables = Types.Exact<{
  input: Types.MinervaViewSummaryInput
}>

export type GetMinervaViewSummaryQuery = {
  __typename?: 'Query'
  minervaViewSummary: {
    __typename?: 'MinervaViewSummaryResponse'
    contextId: string
    title: string | null
    summary: string | null
    citations: Array<{
      __typename?: 'MinervaCitation'
      label: string
      viewId: string
      panelId: string | null
      metricPaths: Array<string>
    }>
  }
}

export const GetMinervaViewSummaryDocument = gql`
    query getMinervaViewSummary($input: MinervaViewSummaryInput!) {
  minervaViewSummary(input: $input) {
    contextId
    title
    summary
    citations {
      label
      viewId
      panelId
      metricPaths
    }
  }
}
    `

/**
 * __useGetMinervaViewSummaryQuery__
 *
 * To run a query within a React component, call `useGetMinervaViewSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMinervaViewSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMinervaViewSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMinervaViewSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMinervaViewSummaryQuery,
    GetMinervaViewSummaryQueryVariables
  > &
    (
      | { variables: GetMinervaViewSummaryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetMinervaViewSummaryQuery,
    GetMinervaViewSummaryQueryVariables
  >(GetMinervaViewSummaryDocument, options)
}
export function useGetMinervaViewSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMinervaViewSummaryQuery,
    GetMinervaViewSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetMinervaViewSummaryQuery,
    GetMinervaViewSummaryQueryVariables
  >(GetMinervaViewSummaryDocument, options)
}
// @ts-ignore
export function useGetMinervaViewSummarySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMinervaViewSummaryQuery,
    GetMinervaViewSummaryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetMinervaViewSummaryQuery,
  GetMinervaViewSummaryQueryVariables
>
export function useGetMinervaViewSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMinervaViewSummaryQuery,
        GetMinervaViewSummaryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetMinervaViewSummaryQuery | undefined,
  GetMinervaViewSummaryQueryVariables
>
export function useGetMinervaViewSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMinervaViewSummaryQuery,
        GetMinervaViewSummaryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetMinervaViewSummaryQuery,
    GetMinervaViewSummaryQueryVariables
  >(GetMinervaViewSummaryDocument, options)
}
export type GetMinervaViewSummaryQueryHookResult = ReturnType<
  typeof useGetMinervaViewSummaryQuery
>
export type GetMinervaViewSummaryLazyQueryHookResult = ReturnType<
  typeof useGetMinervaViewSummaryLazyQuery
>
export type GetMinervaViewSummarySuspenseQueryHookResult = ReturnType<
  typeof useGetMinervaViewSummarySuspenseQuery
>
export type GetMinervaViewSummaryQueryResult = Apollo.QueryResult<
  GetMinervaViewSummaryQuery,
  GetMinervaViewSummaryQueryVariables
>
